/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOrderDtoFromDiscriminatorValue, serializeCreateManyOrdersRequest, serializeOrderDto, type CreateManyOrdersRequest, type ErrorResponse, type InternalErrorResponse, type OrderDto } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/bulk
 */
export interface BulkRequestBuilder extends BaseRequestBuilder<BulkRequestBuilder> {
    /**
     * Bulk-creates or updates orders, grouped by order number. A supplied order number is preserved (re-importing it updates the existing order); omit it to generate one. Set Active=false to soft-delete the matching order.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrderDto[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: CreateManyOrdersRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OrderDto[] | undefined>;
    /**
     * Bulk-creates or updates orders, grouped by order number. A supplied order number is preserved (re-importing it updates the existing order); omit it to generate one. Set Active=false to soft-delete the matching order.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: CreateManyOrdersRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BulkRequestBuilderUriTemplate = "{+baseurl}/api/orders/bulk";
/**
 * Metadata for all the requests in the request builder.
 */
export const BulkRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: BulkRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createOrderDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateManyOrdersRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
